import React from "react";
import { useSettings } from "@/hooks/useSettings";

function Field({ label, value }) {
  const empty = value == null || value === "";
  return (
    <div className="flex items-center justify-between py-2 border-b border-charcoal">
      <span className="font-mono text-xs uppercase tracking-wider text-dim">{label}</span>
      <span className={`font-mono text-xs font-bold ${empty ? "text-danger" : "text-cream"}`}>
        {empty ? "—" : value}
      </span>
    </div>
  );
}

export default function StatusPanel() {
  const { data } = useSettings();
  const state = data?.launchState || "PRE_LAUNCH";
  const rh = data?.chains?.find((c) => c.chainType === "evm");
  const sol = data?.chains?.find((c) => c.chainType === "solana");
  const stat = (c) => (c?.status || "COMING_SOON").replace("_", " ");

  return (
    <div className="comic-card p-6 sm:p-8 relative overflow-hidden" data-testid="status-panel">
      <div className="halftone absolute inset-0 opacity-40 pointer-events-none" />
      <div className="relative">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <h3 className="font-display font-900 text-cream text-2xl">$ROBBED STATUS</h3>
          <span className="tag flex items-center gap-2">
            <span className="w-2.5 h-2.5 rounded-full bg-black animate-pulse" />
            {state.replace("_", "-")}
          </span>
        </div>

        <div className="mt-6 grid sm:grid-cols-2 gap-x-8">
          <Field label="Token" value={state === "LIVE" ? "LIVE" : "NOT DEPLOYED"} />
          <Field label="Robinhood Chain" value={stat(rh)} />
          <Field label="Solana" value={stat(sol)} />
          <Field label="Contract" value={rh?.tokenAddress} />
          <Field label="Mint" value={sol?.mintAddress} />
          <Field label="Liquidity" value={null} />
          <Field label="Holders" value={null} />
          <Field label="Market Cap" value={null} />
        </div>

        <p className="mt-6 font-mono text-[11px] text-dim leading-relaxed">
          We never fake numbers. No price, no holders, no liquidity until the token is verifiably live.
          Everything above stays honest.
        </p>
      </div>
    </div>
  );
}
